export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const imgSrc = (url) => {
  if (!url) return '/images/shop/eco-all-purpose-cleaner.jpg';
  if (url.startsWith('http')) return url;
  if (url.startsWith('/api/')) return `${BACKEND_URL}${url}`;
  return url;
};

export const gbp = (n) => `£${Number(n || 0).toFixed(2)}`;

export const adminHeaders = () => ({ 'X-Admin-Key': sessionStorage.getItem('adminKey') || '' });
